module.exports = __webpack_public_path__ + "media/images/lb/125-eccfed0b51c1600ee6f674d9dbb7e355.svg";